export enum CreditCardPayEnum {
    OriginalCard = 0,
	DifferentCard = 1
}